import React from 'react';

function SvgMadLibBotsForm(props) {
  return (
    <svg viewBox="0 0 665.48 574.1" {...props}>
      <g data-name="Layer 2">
        <g data-name="Layer 1">
          <g data-name="Layer 2">
            <g data-name="MadLib Bots-Form">
              <circle
                cx={185.5}
                cy={87.8}
                r={87.8}
                style={{
                  isolation: 'isolate',
                }}
                fill={props.golda}
                opacity={0.3}
              />
              <circle
                cx={525.4}
                cy={299.7}
                r={61.1}
                transform="rotate(-45 525.41 299.698)"
                style={{
                  isolation: 'isolate',
                }}
                fill={props.reda}
                opacity={0.3}
              />
              <path
                fill="none"
                stroke={props.main}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2.6}
                d="M1.3 570.4h652.9v2.4H1.3z"
              />
              <path
                d="M527.2 570.7H185.5V60.9h341.7zm-340.1-1.6h338.5V62.5H187.1z"
                fill="none"
                stroke={props.main}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2.39}
              />
              <path
                fill="none"
                stroke={props.main}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2.39}
                d="M186.7 83.2h340.1v1.6H186.7z"
              />
              <path
                style={{
                  isolation: 'isolate',
                }}
                fill={props.bluea}
                opacity={0.25}
                d="M186.58 63.57h341.2v19.9h-341.2z"
              />
              <path
                fill="none"
                stroke={props.main}
                strokeLinecap="round"
                strokeMiterlimit={10}
                strokeWidth={2}
                d="M504.7 69.5l8.8 8.8M513.5 69.5l-8.8 8.8"
              />
              <path
                fill="none"
                stroke={props.main}
                strokeLinejoin="round"
                strokeWidth={2}
                d="M486.2 68.4h10.5v10.5h-10.5z"
              />
              <path
                fill="none"
                stroke={props.main}
                strokeLinecap="round"
                strokeMiterlimit={10}
                strokeWidth={2}
                d="M466.8 77.9h13.4"
              />
              <g>
                <path
                  d="M504.9 155.4l-13.6 6.4 12-9a70.58 70.58 0 00-6.6-8.7l-59 14.7 53.3-20.3a75.84 75.84 0 00-7.7-5.9l-90 14.5a67.07 67.07 0 00-14.8 42.1h135.4a65.9 65.9 0 00-9-33.8z"
                  fill={props.greylt}
                />
                <path
                  d="M445.4 186.4l-46.1-68.5s69.8 24.4 61.9 68.5z"
                  fill="none"
                  stroke={props.main}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2.39}
                />
                <path
                  d="M447.2 189.2l46.1-68.5s-69.8 24.4-61.9 68.5zM198.6 147h70.1v8h-70.1z"
                  fill={props.bluea}
                />
                <path
                  fill={props.greylt}
                  d="M198.6 160.5h117.9v4.8H198.6zM198.6 170.9h111.5v4.8H198.6zM198.6 181.2h81.2v4.8h-81.2z"
                />
                <path fill={props.bluea} d="M297.4 503.8h70.1v8h-70.1z" />
                <path
                  fill={props.greylt}
                  d="M297.4 517.3h117.9v4.8H297.4zM207.1 525.9h111.5v4.8H207.1zM207.1 536.2h81.2v4.8h-81.2z"
                />
                <path
                  style={{
                    isolation: 'isolate',
                  }}
                  fill={props.purplea}
                  opacity={0.3}
                  d="M219.7 233h277.2v1.6H219.7z"
                />
                <path
                  fill={props.greylt}
                  d="M225.7 323h46.2v4.8h-46.2zM225.7 333.3h43.7v4.8h-43.7zM225.7 343.7h31.8v4.8h-31.8z"
                />
                <path
                  style={{
                    isolation: 'isolate',
                  }}
                  fill={props.bluea}
                  opacity={0.3}
                  d="M219.3 260.9h58.9v52.6h-58.9z"
                />
                <path fill={props.main} d="M185.9 384.3h340.9v92.4H185.9z" />
                <path fill={props.bluea} d="M198.6 413.8h70.1v8h-70.1z" />
                <path
                  fill={props.greylt}
                  d="M198.6 427.3h117.9v4.8H198.6zM198.6 437.7h111.5v4.8H198.6zM198.6 448h81.2v4.8h-81.2z"
                />
                <circle
                  cx={458.1}
                  cy={424.8}
                  r={24.9}
                  style={{
                    isolation: 'isolate',
                  }}
                  fill={props.bluea}
                  opacity={0.3}
                />
                <circle
                  cx={412}
                  cy={436.7}
                  r={17.5}
                  style={{
                    isolation: 'isolate',
                  }}
                  fill={props.bluea}
                  opacity={0.3}
                />
                <g>
                  <path
                    fill={props.greylt}
                    d="M444.7 323h46.2v4.8h-46.2zM444.7 333.3h43.7v4.8h-43.7zM444.7 343.7h31.8v4.8h-31.8z"
                  />
                  <path
                    fill="none"
                    stroke={props.main}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2.39}
                    d="M438.4 260.9h58.9v52.6h-58.9z"
                  />
                  <g fill={props.main}>
                    <path d="M459.35 285.07v5.07h-1l-2.74-3.07v3.08h-1.25v-5.07h1.05l2.73 3.06v-3.07zM461.78 289.87a2.47 2.47 0 01-1.07-.93 2.51 2.51 0 010-2.69 2.67 2.67 0 011.06-.94 3.24 3.24 0 011.53-.35 3.38 3.38 0 011.53.33 2.63 2.63 0 011.08.93 2.45 2.45 0 01.4 1.34 2.39 2.39 0 01-.39 1.35 2.67 2.67 0 01-1.06.94 3.24 3.24 0 01-1.53.35 3.19 3.19 0 01-1.55-.33zm2.4-.88a1.58 1.58 0 00.83-1.42 1.63 1.63 0 00-.23-.84 1.48 1.48 0 00-.62-.57 2 2 0 00-1.74 0 1.57 1.57 0 00-.83 1.42 1.63 1.63 0 00.23.84 1.46 1.46 0 00.61.57 1.78 1.78 0 00.88.2 1.87 1.87 0 00.87-.19zM467.85 289.58a2.3 2.3 0 01-.66-1.72V285h1.26v2.8c0 .91.42 1.36 1.23 1.36a1.25 1.25 0 00.9-.34 1.39 1.39 0 00.31-1V285h1.25v2.84a2.16 2.16 0 01-.64 1.72 2.55 2.55 0 01-1.81.62 2.67 2.67 0 01-1.84-.6zM478.37 285v5.07h-1l-2.75-3.07v3.08h-1.25V285h1.05l2.73 3.06V285z" />
                  </g>
                </g>
                <g>
                  <path
                    fill={props.greylt}
                    d="M333.2 323h46.2v4.8h-46.2zM333.2 333.3h43.7v4.8h-43.7zM333.2 343.7H365v4.8h-31.8z"
                  />
                  <path
                    fill="none"
                    stroke={props.main}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2.39}
                    d="M326.9 260.9h58.9v52.6h-58.9z"
                  />
                  <g fill={props.main}>
                    <path d="M337.12 289.12h-2.54l-.47 1.09h-1.3l2.41-5.08h1.24l2.47 5.06h-1.32zm-.4-.89l-.88-1.93-.86 1.94zM339.47 285.12H342a3.69 3.69 0 011.57.3 2.57 2.57 0 011.07.89 2.5 2.5 0 010 2.66 2.64 2.64 0 01-1.06.9 3.68 3.68 0 01-1.57.32h-2.48zm2.44 4.1a2 2 0 001.31-.43 1.5 1.5 0 00.48-1.16 1.46 1.46 0 00-.5-1.14 1.89 1.89 0 00-1.31-.42h-1.15v3.14zM345.81 290.05a1.8 1.8 0 01-.76-.54l.7-.79a1.3 1.3 0 001 .56c.52 0 .77-.29.77-.85V286h-1.92v-.94h3.18v3.29a1.76 1.76 0 01-.49 1.4 2 2 0 01-1.46.48 2.53 2.53 0 01-1.02-.18zM354.26 289.17v.94H350V285h4.13v1h-2.87v1.1h2.53v.9h-2.54v1.17zM356.36 289.85a2.74 2.74 0 01-1.07-.93 2.39 2.39 0 01-.39-1.35 2.44 2.44 0 01.38-1.36 2.64 2.64 0 011.05-.94 3.45 3.45 0 011.52-.34 3.29 3.29 0 011.28.22 2.57 2.57 0 011 .66l-.81.7a1.78 1.78 0 00-1.37-.58 1.9 1.9 0 00-.91.21 1.42 1.42 0 00-.61.58 1.68 1.68 0 000 1.68 1.37 1.37 0 00.62.57 1.88 1.88 0 00.9.2 1.74 1.74 0 001.37-.61l.82.69a2.38 2.38 0 01-1 .68 3.61 3.61 0 01-2.78-.08zM362 286h-1.74v-1H365v1h-1.74v4.11H362zM365.71 285H367v5.07h-1.26zM373.48 284.92l-2.33 5.08h-1.25l-2.38-5h1.36l1.68 3.61 1.66-3.63zM378.18 289v1H374v-5.07h4.13v.94h-2.87V287h2.53v.91h-2.54V289z" />
                  </g>
                </g>
              </g>
              <g>
                <path
                  fill="none"
                  stroke={props.main}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2.39}
                  d="M199.129 276.364l15.106-50.385 56.419 16.916-15.107 50.384z"
                />
                <g fill={props.main}>
                  <path d="M231.71 246.47l-1.46 4.86-1-.3-1.72-3.73-.89 2.95-1.19-.36 1.46-4.86 1 .3 1.71 3.73.89-2.95zM235.25 251.69l-2.43-.73-.78.9-1.24-.37 3.79-4.16 1.2.36.88 5.56-1.27-.38zm-.13-1l-.27-2.11-1.39 1.62zM242 254.84l.87-2.91-2.26 1.94-.55-.17-.83-2.79-.85 2.85-1.14-.34 1.46-4.86 1 .3 1.05 3.6 2.83-2.43 1 .29-1.45 4.87zM248.66 255.87l-.27.9-4-1.21 1.46-4.86 4 1.19-.27.9-2.75-.83-.32 1.06 2.43.73-.26.87-2.43-.73-.34 1.13z" />
                  <g>
                    <path d="M230.48 260.21a2.53 2.53 0 01-.75-1.2 2.49 2.49 0 01.77-2.58 2.68 2.68 0 011.29-.59 3.22 3.22 0 011.57.12 3.31 3.31 0 011.37.76 2.78 2.78 0 01.75 1.21 2.39 2.39 0 010 1.4 2.3 2.3 0 01-.76 1.17 2.59 2.59 0 01-1.29.59 3.57 3.57 0 01-2.93-.88zm2.55-.13a1.71 1.71 0 00.76-.38 1.58 1.58 0 00.45-.74 1.61 1.61 0 000-.87 1.5 1.5 0 00-.42-.73 2 2 0 00-.78-.45 1.79 1.79 0 00-.89-.05 1.57 1.57 0 00-.76.38 1.7 1.7 0 00-.48 1.6 1.5 1.5 0 00.42.73 1.86 1.86 0 00.78.45 1.92 1.92 0 00.89.06zM238 258.44l-.38 1.28 2.42.73-.27.9-2.42-.73-.53 1.77-1.21-.36 1.46-4.86 3.94 1.19-.27.9z" />
                  </g>
                  <g>
                    <path d="M217.89 263.51a1.26 1.26 0 01-.72 1.63h-.08a3 3 0 01-1.66-.13l-2.71-.81 1.46-4.86 2.56.77a2.71 2.71 0 011.36.78 1.14 1.14 0 01.24 1.08 1.22 1.22 0 01-.38.57 1.18 1.18 0 01-.64.29 1.4 1.4 0 01.57.68zm-1.53.73a.52.52 0 00.38-.38c.12-.4-.15-.7-.79-.89l-1.41-.43-.36 1.2 1.41.43a1.55 1.55 0 00.77.07zm-1.23-3.66l-.34 1.14 1.2.36a1.27 1.27 0 00.72.06.47.47 0 00.36-.36.45.45 0 00-.1-.49 1.44 1.44 0 00-.64-.35zM219.16 265.62a2.25 2.25 0 01-.13-1.83l.82-2.72 1.21.37-.8 2.68c-.27.86 0 1.42.77 1.65a1.21 1.21 0 001-.06 1.48 1.48 0 00.59-.89l.81-2.68 1.19.36-.81 2.71a2.18 2.18 0 01-1.12 1.46 3.06 3.06 0 01-3.49-1.05zM224.86 267.79a3.12 3.12 0 01-.81-.68l.67-.72a3 3 0 00.69.6 3 3 0 00.88.42 1.82 1.82 0 00.8.09.43.43 0 00.36-.31.38.38 0 000-.33 1.47 1.47 0 00-.32-.29 5.36 5.36 0 00-.57-.34c-.37-.21-.67-.4-.9-.56a1.59 1.59 0 01-.53-.62 1.16 1.16 0 010-.86 1.52 1.52 0 01.48-.69 1.75 1.75 0 01.91-.32 3.22 3.22 0 011.27.16 4.62 4.62 0 01.94.41 3 3 0 01.75.57l-.63.74a3.2 3.2 0 00-1.34-.82 1.42 1.42 0 00-.79-.07.46.46 0 00-.37.33.4.4 0 00.17.45 4.51 4.51 0 00.78.5 7.07 7.07 0 01.9.56 1.49 1.49 0 01.53.61 1 1 0 010 .85 1.3 1.3 0 01-.48.69 1.74 1.74 0 01-.91.31 3.27 3.27 0 01-1.28-.16 4.74 4.74 0 01-1.2-.52zM230.54 264.28l1.21.37-1.46 4.85-1.21-.36zM237.79 266.46l-1.46 4.86-1-.3-1.72-3.73-.88 2.95-1.2-.36L233 265l1 .3 1.72 3.73.88-2.95zM241.88 272l-.27.91-4-1.22 1.46-4.86L243 268l-.27.9-2.74-.83-.32 1.06 2.43.73-.27.87-2.42-.73-.34 1.13zM243.12 273.28a2.83 2.83 0 01-.81-.69l.66-.72a3.08 3.08 0 00.69.61 3.41 3.41 0 00.89.41 1.55 1.55 0 00.8.09.43.43 0 00.36-.3.35.35 0 00-.06-.34 1.47 1.47 0 00-.32-.29 4.08 4.08 0 00-.57-.34 10.4 10.4 0 01-.9-.56 1.65 1.65 0 01-.52-.62 1.07 1.07 0 010-.86 1.3 1.3 0 01.48-.69 1.72 1.72 0 01.9-.32 3.27 3.27 0 011.28.16 4.62 4.62 0 01.94.41 3.12 3.12 0 01.74.57l-.63.74a3.23 3.23 0 00-1.33-.82 1.56 1.56 0 00-.8-.07.47.47 0 00-.36.33.42.42 0 00.17.46 4.86 4.86 0 00.78.49c.37.21.67.4.9.56a1.83 1.83 0 01.53.61 1.14 1.14 0 010 .85 1.3 1.3 0 01-.48.69 1.75 1.75 0 01-.91.32 3.28 3.28 0 01-1.28-.17 4.39 4.39 0 01-1.15-.51zM247.88 274.71a3.16 3.16 0 01-.81-.69l.67-.72a3.08 3.08 0 00.69.61 3.56 3.56 0 00.88.42 1.68 1.68 0 00.8.08.43.43 0 00.36-.3.33.33 0 00-.06-.33 1.11 1.11 0 00-.31-.3c-.14-.09-.33-.21-.57-.34a10.4 10.4 0 01-.9-.56 1.59 1.59 0 01-.53-.62 1.14 1.14 0 010-.85 1.37 1.37 0 01.48-.7 1.75 1.75 0 01.91-.32 3.64 3.64 0 011.27.16 4.62 4.62 0 01.94.41 3.12 3.12 0 01.74.57l-.62.74a3.2 3.2 0 00-1.34-.82 1.56 1.56 0 00-.8-.07.48.48 0 00-.36.33.42.42 0 00.17.46 4.86 4.86 0 00.78.49c.37.21.67.4.9.56a1.63 1.63 0 01.53.61 1 1 0 010 .85 1.3 1.3 0 01-.48.69 1.75 1.75 0 01-.91.32 3.28 3.28 0 01-1.28-.17 4.92 4.92 0 01-1.15-.51z" />
                  </g>
                </g>
              </g>
              <g>
                <path fill={props.greymd} d="M122.9 378.7h22.7v10.2h-22.7z" />
                <path
                  fill="none"
                  stroke={props.main}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2.98}
                  d="M122.9 379h22.7v9.7h-22.7z"
                />
                <path fill={props.greymd} d="M122.9 384h31.6v10.2h-31.6z" />
                <path
                  fill="none"
                  stroke={props.main}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={3.56}
                  d="M122.9 384.2h32.4v9.7h-32.4z"
                />
                <path fill={props.greymd} d="M113.5 380.5h22.7v10.2h-22.7z" />
                <path
                  fill="none"
                  stroke={props.main}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2.98}
                  d="M113.5 380.7h22.7v9.7h-22.7z"
                />
                <path fill={props.greymd} d="M113.5 385.8h31.6V396h-31.6z" />
                <path
                  fill="none"
                  stroke={props.main}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={3.56}
                  d="M113.5 386h32.4v9.7h-32.4z"
                />
                <g>
                  <path
                    d="M166.8 330s29.8-14.2 32.3-45.6l-6.9-2.8s-4.4 26.3-28.6 40.8"
                    fill={props.greymd}
                  />
                  <path
                    d="M167.4 330.3s29.5-14.8 31.3-46.2l-6.9-2.7s-3.8 26.4-27.7 41.4"
                    fill="none"
                    stroke={props.main}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2.57}
                  />
                  <path
                    fill="none"
                    stroke={props.main}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={1.18}
                    d="M173.3 325.9l-4.4-6.5M178.9 321l-5-5.8M184.2 316.4l-5.6-5.6M195 299.3l-6.7-3.9M188.2 311.1l-6.1-5M192.2 305.1l-6.5-4.7M197.5 291.6l-6.7-2.8"
                  />
                  <path
                    d="M192.3 269.5c-1.7 6.8-2.3 13.7 3.3 15.1s8.7-4.8 10.4-11.6l-4.3.4c-.8 3.4-1.9 6.4-4.6 5.8s-2.1-3.3-1.2-6.7z"
                    fill={props.greymd}
                  />
                  <path
                    d="M192.3 269.5c-1.7 6.8-2.3 13.7 3.3 15.1s8.7-4.8 10.4-11.6l-4.3.4c-.8 3.4-1.9 6.4-4.6 5.8s-2.1-3.3-1.2-6.7z"
                    fill="none"
                    stroke={props.main}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={1.91}
                  />
                </g>
                <g>
                  <path
                    d="M119.2 328.7s-28.8 16.1-29.3 47.6l7 2.3s2.7-26.6 25.9-42.6"
                    fill={props.greymd}
                  />
                  <path
                    d="M119.2 328.7s-28.8 16.1-29.3 47.6l7 2.3s2.7-26.6 25.9-42.6"
                    fill="none"
                    stroke={props.main}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2.57}
                  />
                  <path
                    fill="none"
                    stroke={props.main}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={1.18}
                    d="M113 333.2l4.9 6.3M107.7 338.5l5.4 5.5M102.8 343.4l5.9 5.2M93.1 361.2l6.9 3.4M99.2 349l6.4 4.6M95.5 355.2l6.8 4.3M91.2 369l6.8 2.4"
                  />
                  <path
                    d="M97.6 390.8c1.2-6.9 1.4-13.8-4.2-14.8s-8.4 5.3-9.6 12.2l4.3-.7c.6-3.4 1.4-6.5 4.2-6s2.3 3.2 1.7 6.6z"
                    fill={props.greymd}
                  />
                  <path
                    d="M97.6 390.8c1.2-6.9 1.4-13.8-4.2-14.8s-8.4 5.3-9.6 12.2l4.3-.7c.6-3.4 1.4-6.5 4.2-6s2.3 3.2 1.7 6.6z"
                    fill="none"
                    stroke={props.main}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={1.91}
                  />
                </g>
                <g>
                  <path
                    d="M164 379.4H97.5a3.54 3.54 0 01-3.5-3.5v-62.5a3.54 3.54 0 013.5-3.5H164a3.54 3.54 0 013.5 3.5v62.5a3.48 3.48 0 01-3.46 3.5z"
                    fill={props.greymd}
                  />
                  <path
                    d="M162.8 379.4H96.3a3.54 3.54 0 01-3.5-3.5v-62.5a3.54 3.54 0 013.5-3.5h66.5a3.54 3.54 0 013.5 3.5v62.5a3.48 3.48 0 01-3.46 3.5h0z"
                    fill="none"
                    stroke={props.main}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2.68}
                  />
                  <g
                    fill="none"
                    stroke={props.main}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2.57}
                  >
                    <path d="M151 348.6v13.9M157.8 348.6v13.9M164.5 348.6v13.9" />
                  </g>
                  <g
                    stroke={props.main}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path
                      fill={props.greymd}
                      strokeWidth={2.22}
                      d="M114.9 305.2h31.5v4.9h-31.5z"
                    />
                    <path
                      fill="none"
                      strokeWidth={1.18}
                      d="M119.4 305.2v4.5M124.2 305.2v4.5M128.8 305.5v4.5M133.2 305.5v4.5M142.3 305.2v4.5M137.8 305.5v4.5"
                    />
                  </g>
                  <path
                    d="M164 343.6h-17.5a1 1 0 01-1-1v-17.7a1 1 0 011-1H164a1 1 0 011 1v17.7a1 1 0 01-1 1z"
                    style={{
                      isolation: 'isolate',
                    }}
                    fill={props.bota}
                    opacity={0.3}
                  />
                  <path
                    d="M165.4 342.7h-19.1a.9.9 0 01-.9-.9V326a.9.9 0 01.9-.9h19.1a.9.9 0 01.9.9v15.8a1 1 0 01-.9.9z"
                    fill="none"
                    stroke={props.main}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={1.99}
                  />
                </g>
                <g>
                  <circle cx={150.2} cy={228.7} r={6.2} fill={props.greymd} />
                  <path
                    d="M130.7 244s.6-11 11.4-13.3"
                    fill="none"
                    stroke={props.main}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2.57}
                  />
                  <circle
                    cx={149.6}
                    cy={228.7}
                    r={6.2}
                    fill="none"
                    stroke={props.main}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2.57}
                  />
                  <path
                    d="M162.9 305H96.2a3.37 3.37 0 01-3.4-3.34h0V244.3a3.37 3.37 0 013.34-3.4H163a3.37 3.37 0 013.4 3.34h0v57.36a3.52 3.52 0 01-3.5 3.4z"
                    fill="none"
                    stroke={props.main}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2.57}
                  />
                  <path
                    d="M162.9 305H96.2a3.37 3.37 0 01-3.4-3.34V244.3a3.37 3.37 0 013.34-3.4H163a3.37 3.37 0 013.4 3.34v57.36a3.52 3.52 0 01-3.5 3.4z"
                    fill={props.greymd}
                  />
                  <path
                    d="M114 281.4a7.1 7.1 0 010-14.2"
                    fill={props.greydk}
                    stroke={props.main}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2.57}
                  />
                  <g>
                    <circle
                      cx={139.6}
                      cy={282.2}
                      r={6.4}
                      style={{
                        isolation: 'isolate',
                      }}
                      fill={props.bota}
                      opacity={0.3}
                    />
                    <circle cx={150.2} cy={265.2} r={4} fill={props.main} />
                    <path
                      d="M152.9 287.2c0-2.2.8-5.7 3-5.7s2.9 3.5 2.9 5.7"
                      fill={props.pinka}
                      stroke={props.main}
                      strokeLinecap="round"
                      strokeMiterlimit={10}
                      strokeWidth={1.37}
                    />
                    <path
                      fill="none"
                      stroke={props.main}
                      strokeLinecap="round"
                      strokeMiterlimit={10}
                      strokeWidth={2.33}
                      d="M165.3 288l-14-1.6"
                    />
                  </g>
                </g>
              </g>
              <g>
                <g data-name="ArmLeft">
                  <path
                    d="M77.8 492s-32-17.9-32.5-52.8l7.8-2.6s3 29.5 28.7 47.3"
                    fill="none"
                    stroke={props.main}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2.85}
                  />
                  <path
                    fill="none"
                    stroke={props.main}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={1.31}
                    d="M70.9 487l5.5-7M65.1 481.1L71 475M59.6 475.7l6.6-5.8M48.9 455.9l7.6-3.8M55.6 469.5l7.1-5.1"
                  />
                  <path
                    d="M77.8 492s-32-17.9-32.5-52.8l7.8-2.6s3 29.5 28.7 47.3"
                    fill="none"
                    stroke={props.main}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2.12}
                  />
                  <path
                    fill="none"
                    stroke={props.main}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={1.31}
                    d="M51.5 462.5l7.6-4.7M46.7 447.2l7.5-2.5"
                  />
                  <path
                    d="M53.8 423c1.3 7.6 1.5 15.4-4.7 16.4s-9.3-5.9-10.6-13.5l4.7.8c.7 3.8 1.6 7.2 4.7 6.7s2.5-3.5 1.9-7.3z"
                    fill={props.greymd}
                  />
                  <path
                    d="M53.8 423c1.3 7.6 1.5 15.4-4.7 16.4s-9.3-5.9-10.6-13.5l4.7.8c.7 3.8 1.6 7.2 4.7 6.7s2.5-3.5 1.9-7.3z"
                    fill="none"
                    stroke={props.main}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2.12}
                  />
                </g>
                <g data-name="ArmRight">
                  <path
                    d="M153.3 493.6s32-17.9 32.5-52.8l-7.8-2.6s-3 29.5-28.7 47.3"
                    fill={props.greymd}
                  />
                  <path
                    d="M153.3 493.6s32-17.9 32.5-52.8l-7.8-2.6s-3 29.5-28.7 47.3"
                    fill="none"
                    stroke={props.main}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2.85}
                  />
                  <path
                    fill="none"
                    stroke={props.main}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={1.31}
                    d="M160.2 488.6l-5.4-6.9M166 482.8l-5.9-6.1M171.5 477.3l-6.5-5.7M182.2 457.6l-7.6-3.8M175.5 471.2l-7.1-5.2M179.6 464.2l-7.5-4.7M184.4 448.9l-7.5-2.6"
                  />
                  <path
                    d="M177.3 424.7c-1.3 7.6-1.5 15.4 4.7 16.4s9.3-5.9 10.6-13.5l-4.7.8c-.7 3.8-1.6 7.2-4.7 6.7s-2.5-3.5-1.9-7.3z"
                    fill={props.greymd}
                  />
                  <path
                    d="M177.3 424.7c-1.3 7.6-1.5 15.4 4.7 16.4s9.3-5.9 10.6-13.5l-4.7.8c-.7 3.8-1.6 7.2-4.7 6.7s-2.5-3.5-1.9-7.3z"
                    fill="none"
                    stroke={props.main}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2.12}
                  />
                </g>
                <path
                  data-name="BodyBack"
                  d="M153.5 550.5H79.7a3.92 3.92 0 01-3.9-3.9v-69.3a3.92 3.92 0 013.9-3.9h73.8a3.92 3.92 0 013.9 3.9v69.3a3.84 3.84 0 01-3.78 3.9h-.12z"
                  fill={props.greymd}
                />
                <path
                  data-name="BodyPath"
                  d="M152.2 550.5H78.4a3.92 3.92 0 01-3.9-3.9h0v-69.3a3.92 3.92 0 013.9-3.9h73.8a3.92 3.92 0 013.9 3.9v69.3a3.84 3.84 0 01-3.78 3.9h-.12z"
                  fill="none"
                  stroke={props.main}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2.97}
                />
                <g
                  data-name="Neck"
                  stroke={props.main}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path
                    fill={props.greymd}
                    strokeWidth={2.46}
                    d="M99.1 468.2h35v5.4h-35z"
                  />
                  <path
                    fill="none"
                    strokeWidth={1.31}
                    d="M104.1 468.2v4.9M109.4 468.2v4.9M114.5 468.5v4.9M119.4 468.5v4.9M129.5 468.2v4.9M124.5 468.5v4.9"
                  />
                </g>
                <g data-name="ChestPlate">
                  <path
                    d="M133.8 509H97.7a1.43 1.43 0 01-1.4-1.4v-16.9a1.43 1.43 0 011.4-1.4h36.1a1.43 1.43 0 011.4 1.4v16.9a1.37 1.37 0 01-1.34 1.4h-.06z"
                    style={{
                      isolation: 'isolate',
                    }}
                    fill={props.botb}
                    opacity={0.3}
                  />
                  <path
                    d="M133.8 508.5H97.7a1.43 1.43 0 01-1.4-1.4v-16.9a1.43 1.43 0 011.4-1.4h36.1a1.43 1.43 0 011.4 1.4v16.9a1.37 1.37 0 01-1.34 1.4h-.06z"
                    fill="none"
                    stroke={props.main}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2.85}
                  />
                </g>
                <g
                  data-name="ChestGrill"
                  fill="none"
                  stroke={props.main}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2.85}
                >
                  <path d="M97.5 517v15.4M105.1 517v15.4M112.5 517v15.4M119.5 517v15.4M134.1 517v15.4M126.9 517v15.4" />
                </g>
                <g>
                  <g data-name="LegRight">
                    <path fill={props.greymd} d="M122.6 552h25.1v11.3h-25.1z" />
                    <path
                      fill="none"
                      stroke={props.main}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={3.3}
                      d="M122.6 552h25.1v10.7h-25.1z"
                    />
                    <path
                      d="M149.7 567.8c0-5.6-6.4-10.2-14.3-10.2s-14.3 4.6-14.3 10.2z"
                      fill={props.greymd}
                    />
                    <path
                      d="M149.5 567.8c0-5.6-6.4-10.2-14.3-10.2s-14.3 4.6-14.3 10.2z"
                      fill="none"
                      stroke={props.main}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={3.13}
                    />
                  </g>
                  <g data-name="LegLeft">
                    <path fill={props.greymd} d="M85.3 552h25.1v11.3H85.3z" />
                    <path
                      fill="none"
                      stroke={props.main}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={3.05}
                      d="M85.3 552h25.1v10.7H85.3z"
                    />
                    <path
                      d="M112.3 567.8c0-5.6-6.4-10.2-14.3-10.2s-14.3 4.6-14.3 10.2z"
                      fill={props.greymd}
                    />
                    <path
                      d="M112.2 567.8c0-5.6-6.4-10.2-14.3-10.2s-14.3 4.6-14.3 10.2z"
                      fill="none"
                      stroke={props.main}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={3.13}
                    />
                  </g>
                </g>
                <g>
                  <path
                    data-name="Headback"
                    d="M152.4 467.9H78.3a3.69 3.69 0 01-3.7-3.68V400.6a3.69 3.69 0 013.68-3.7h74.12a3.69 3.69 0 013.7 3.68v63.62a3.69 3.69 0 01-3.68 3.7z"
                    fill={props.greymd}
                  />
                  <path
                    d="M74.1 441.8a7.8 7.8 0 110-15.6M156.6 426.1a7.8 7.8 0 110 15.6"
                    fill={props.greydk}
                    stroke={props.main}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2.85}
                  />
                  <g data-name="Antenna">
                    <path
                      d="M116.6 400.2s.7-12.2 12.6-14.7"
                      fill="none"
                      stroke={props.main}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2.85}
                    />
                    <circle cx={138.2} cy={383.3} r={6.9} fill={props.greymd} />
                    <circle
                      cx={137.6}
                      cy={383.3}
                      r={6.9}
                      fill="none"
                      stroke={props.main}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2.85}
                    />
                  </g>
                  <path
                    data-name="HeadPath"
                    d="M152.4 467.9H78.3a3.69 3.69 0 01-3.7-3.68h0V400.6a3.69 3.69 0 013.68-3.7h74.12a3.69 3.69 0 013.7 3.68h0v63.62a3.69 3.69 0 01-3.68 3.7h0z"
                    fill="none"
                    stroke={props.main}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2.85}
                  />
                  <g data-name="Face">
                    <circle
                      cx={93}
                      cy={428.2}
                      r={7.1}
                      style={{
                        isolation: 'isolate',
                      }}
                      fill={props.botb}
                      opacity={0.3}
                    />
                    <circle
                      cx={137.7}
                      cy={428.9}
                      r={7.1}
                      style={{
                        isolation: 'isolate',
                      }}
                      fill={props.botb}
                      opacity={0.3}
                    />
                    <circle cx={102} cy={414.4} r={4.4} fill={props.main} />
                    <circle cx={126.9} cy={414.4} r={4.4} fill={props.main} />
                    <path
                      d="M124.1 433.3c0 2.4-3.2 4.3-7 4.3s-7-1.9-7-4.3 1.7-4.2 5.6-4.2 8.4 1.8 8.4 4.2z"
                      fill={props.main}
                    />
                  </g>
                </g>
              </g>
              <g>
                <g data-name="ArmRight">
                  <path
                    d="M628.5 503.4s27.6-13.1 29.9-42.1l-6.3-2.6s-4.1 24.3-26.5 37.8"
                    fill={props.greymd}
                  />
                  <path
                    d="M628.5 503.4s27.6-13.1 29.9-42.1l-6.3-2.6s-4.1 24.3-26.5 37.8"
                    fill="none"
                    stroke={props.main}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2.38}
                  />
                  <path
                    fill="none"
                    stroke={props.main}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={1.09}
                    d="M634.5 499.6l-4.2-6M639.7 495.1l-4.7-5.4M644.5 490.9l-5.1-5.2M654.5 475l-6.1-3.5M648.2 486l-5.6-4.7M652 480.4l-6-4.4M656.8 467.9l-6.1-2.5"
                  />
                  <path
                    d="M652 447.5c-1.5 6.3-2.1 12.7 3 13.9s8.1-4.4 9.6-10.7l-4 .4c-.8 3.1-1.7 5.9-4.3 5.3s-1.9-3.1-1.1-6.2z"
                    fill={props.greymd}
                  />
                  <path
                    d="M652 447.5c-1.5 6.3-2.1 12.7 3 13.9s8.1-4.4 9.6-10.7l-4 .4c-.8 3.1-1.7 5.9-4.3 5.3s-1.9-3.1-1.1-6.2z"
                    fill="none"
                    stroke={props.main}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={1.77}
                  />
                </g>
                <g data-name="ArmLeft">
                  <path
                    d="M564.1 495.6s-26.6 14.9-27.1 44l6.5 2.2s2.5-24.5 23.9-39.4"
                    fill={props.greymd}
                  />
                  <path
                    d="M564.1 495.6s-26.6 14.9-27.1 44l6.5 2.2s2.5-24.5 23.9-39.4"
                    fill="none"
                    stroke={props.main}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2.38}
                  />
                  <path
                    fill="none"
                    stroke={props.main}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={1.09}
                    d="M558.3 499.7l4.6 5.8M553.5 504.6l4.9 5.1M548.9 509.1l5.5 4.8M540 525.6l6.3 3.1M545.5 514.3l6 4.2M542.1 520.1l6.3 3.9M538.1 532.8l6.3 2.2"
                  />
                  <path
                    d="M544.1 553c1.1-6.4 1.2-12.8-3.9-13.7s-7.8 4.9-8.9 11.3l3.9-.6c.6-3.2 1.3-6 3.9-5.6s2.1 2.9 1.5 6.1z"
                    fill={props.greymd}
                  />
                  <path
                    d="M544.1 553c1.1-6.4 1.2-12.8-3.9-13.7s-7.8 4.9-8.9 11.3l3.9-.6c.6-3.2 1.3-6 3.9-5.6s2.1 2.9 1.5 6.1z"
                    fill="none"
                    stroke={props.main}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={1.77}
                  />
                </g>
                <path
                  data-name="BodyBack"
                  d="M626.6 553.7h-61.4a3.15 3.15 0 01-3.2-3.1v-57.8a3.15 3.15 0 013.1-3.2h61.6a3.15 3.15 0 013.2 3.1v57.8a3.31 3.31 0 01-3.3 3.2z"
                  fill={props.greymd}
                />
                <path
                  data-name="BodyPath"
                  d="M625.5 553.7H564a3.15 3.15 0 01-3.2-3.1v-57.8a3.15 3.15 0 013.1-3.2h61.6a3.15 3.15 0 013.2 3.1v57.8a3.1 3.1 0 01-3 3.2h-.2z"
                  fill="none"
                  stroke={props.main}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2.48}
                />
                <g
                  data-name="Neck"
                  stroke={props.main}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path
                    fill={props.greymd}
                    strokeWidth={2.05}
                    d="M581.3 485.1h29.2v4.5h-29.2z"
                  />
                  <path
                    fill="none"
                    strokeWidth={1.09}
                    d="M585.4 485.1v4.1M589.8 485.1v4.1M594.1 485.4v4.1M598.2 485.4v4.1M606.6 485.1v4.1M602.4 485.4v4.1"
                  />
                </g>
                <g data-name="ChestPlate">
                  <path
                    d="M610.2 519.1h-30.1a1.11 1.11 0 01-1.1-1.1v-14.1a1.11 1.11 0 011.1-1.1h30.1a1.11 1.11 0 011.1 1.1V518a1.11 1.11 0 01-1.1 1.1z"
                    style={{
                      isolation: 'isolate',
                    }}
                    fill={props.botc}
                    opacity={0.3}
                  />
                  <path
                    d="M610.2 518.7h-30.1a1.11 1.11 0 01-1.1-1.1v-14.1a1.11 1.11 0 011.1-1.1h30.1a1.11 1.11 0 011.1 1.1v14.1a1.11 1.11 0 01-1.1 1.1z"
                    fill="none"
                    stroke={props.main}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2.38}
                  />
                </g>
                <g
                  data-name="ChestGrill"
                  fill="none"
                  stroke={props.main}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2.38}
                >
                  <path d="M579.9 525.8v12.8M586.3 525.8v12.8M592.5 525.8v12.8M598.3 525.8v12.8M610.4 525.8v12.8M604.4 525.8v12.8" />
                </g>
                <g>
                  <path fill={props.greymd} d="M600.9 554.9h20.9v9.4h-20.9z" />
                  <path
                    fill="none"
                    stroke={props.main}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2.75}
                    d="M600.9 554.9h20.9v8.9h-20.9z"
                  />
                  <path
                    d="M623.4 568.1c0-4.7-5.4-8.5-12-8.5s-12 3.8-12 8.5z"
                    fill={props.greymd}
                  />
                  <path
                    d="M623.3 568.1c0-4.7-5.4-8.5-12-8.5s-12 3.8-12 8.5z"
                    fill="none"
                    stroke={props.main}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2.61}
                  />
                </g>
                <g>
                  <path fill={props.greymd} d="M569.8 554.9h20.9v9.4h-20.9z" />
                  <path
                    fill="none"
                    stroke={props.main}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2.54}
                    d="M569.8 554.9h20.9v8.9h-20.9z"
                  />
                  <path
                    d="M592.3 568.1c0-4.7-5.4-8.5-12-8.5s-12 3.8-12 8.5z"
                    fill={props.greymd}
                  />
                  <path
                    d="M592.2 568.1c0-4.7-5.4-8.5-12-8.5s-12 3.8-12 8.5z"
                    fill="none"
                    stroke={props.main}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2.61}
                  />
                </g>
                <g>
                  <path
                    data-name="EarLeft"
                    d="M560.4 463.1a6.5 6.5 0 010-13"
                    fill={props.greydk}
                    stroke={props.main}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2.38}
                  />
                  <path
                    data-name="EarRight"
                    d="M629.2 450a6.5 6.5 0 010 13"
                    fill={props.greydk}
                    stroke={props.main}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2.38}
                  />
                  <path
                    data-name="HeadBack"
                    d="M625.7 484.9H564a3.12 3.12 0 01-3.1-3.1v-53a3.12 3.12 0 013.1-3.1h61.7a3.12 3.12 0 013.1 3.1v53a3.12 3.12 0 01-3.1 3.1z"
                    fill={props.greymd}
                  />
                  <path
                    data-name="HeadPath"
                    d="M625.7 484.9H564a3.12 3.12 0 01-3.1-3.1v-53a3.12 3.12 0 013.1-3.1h61.7a3.12 3.12 0 013.1 3.1v53a3.12 3.12 0 01-3.1 3.1z"
                    fill="none"
                    stroke={props.main}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2.38}
                  />
                  <g data-name="Antenna">
                    <circle cx={613.9} cy={414.4} r={5.8} fill={props.greymd} />
                    <path
                      d="M595.9 428.5s.6-10.2 10.5-12.3"
                      fill="none"
                      stroke={props.main}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2.38}
                    />
                    <circle
                      cx={613.4}
                      cy={414.4}
                      r={5.8}
                      fill="none"
                      stroke={props.main}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2.38}
                    />
                  </g>
                  <circle
                    cx={576.4}
                    cy={465.2}
                    r={5.9}
                    style={{
                      isolation: 'isolate',
                    }}
                    fill={props.botc}
                    opacity={0.3}
                  />
                  <circle
                    cx={613.9}
                    cy={465.2}
                    r={5.9}
                    style={{
                      isolation: 'isolate',
                    }}
                    fill={props.botc}
                    opacity={0.3}
                  />
                  <path
                    d="M602.3 459.4c.2 3-2.9 5.6-6.8 5.8s-7.2-2-7.4-5"
                    fill="none"
                    stroke={props.main}
                    strokeLinecap="round"
                    strokeMiterlimit={10}
                    strokeWidth={3.17}
                  />
                  <circle cx={580.1} cy={450} r={3.7} fill={props.main} />
                  <path
                    fill="none"
                    stroke={props.main}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2.63}
                    d="M609.8 447.5l-4.9 3.7 6 1.3"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default SvgMadLibBotsForm;
